import { RewardsChart } from '@components/rewards/RewardsChart';
import { RewardsOverview } from '@components/rewards/RewardsOverview';
import { RewardsRedemption } from '@components/rewards/RewardsRedemption';
import { EcoButton, EcoCard, EcoText } from '@components/shared';
import { EcoPageTitle } from '@components/shared/EcoPageTitle';
import { EcoSeparator } from '@components/shared/EcoSeparator';
import EcoScrollView from '@components/views/EcoScrollView';
import { useFeaturePermission } from '@hooks/useFeaturePermission';
import { useGlobal } from '@hooks/useGlobal';
import { useOverlay } from '@hooks/useOverlay';
import { useNavigation } from '@react-navigation/native';
import { Gap } from '@utils/layout';
import React from 'react';
import { Linking, Pressable, View } from 'react-native';
import { GlobalScreenProps } from '../navigation/types';

export default function RewardsScreen({}: GlobalScreenProps): JSX.Element {
  const { session } = useGlobal();
  const { showModal } = useOverlay();
  const navigation = useNavigation();
  const { isFeaturePermissioned } = useFeaturePermission('qa');

  const shopName = session?.merchantAdmin?.shopName;
  if (!session?.merchantAdmin?.enableEcoRewards || !shopName) return <></>;

  const openFAQPage = () => Linking.openURL('https://support.ecocart.io/knowledge/faq-ecocart-rewards?hs_preview=GXbsZqcz-164047940272');

  const handleShowLearnMoreModal = () => {
    showModal({
      nativeID: 'edit-credit-card-modal',
      content: (
        <EcoCard size="lg">
          <View style={Gap(4)}>
            <EcoText fontSize="lg">What is EcoCart Rewards?</EcoText>
            <EcoSeparator />
            <EcoText>
              Earn rewards for your customers' carbon offsets! EcoCart Rewards allows you to earn a share of our profits. Use your rewards
              for various purposes to enhance your sustainability and marketing efforts.
            </EcoText>
            <EcoText>
              Got more questions? Please check out the{' '}
              <Pressable onPress={openFAQPage}>
                <EcoText color="link">FAQ page.</EcoText>
              </Pressable>
            </EcoText>
          </View>
        </EcoCard>
      )
    });
  };

  const openHistoryPage = () => {
    navigation.navigate('RewardsHistory');
  };

  return (
    <EcoScrollView>
      <View className="flex-row items-start justify-between">
        <EcoPageTitle
          className="mb-5"
          title="Rewards"
          subTitle={
            <>
              <EcoText>Earn cash when your customers offset their purchases. </EcoText>
              <Pressable onPress={handleShowLearnMoreModal}>
                <EcoText className="underline">Learn more</EcoText>
              </Pressable>
            </>
          }
        />
        <View className="flex-row gap-2">
          {isFeaturePermissioned && (
            <EcoButton onPress={openHistoryPage} size="sm" variant="outlined">
              View History
            </EcoButton>
          )}
          <EcoButton onPress={openFAQPage} rightIcon="open_in_new" size="sm" variant="ghost">
            FAQ
          </EcoButton>
        </View>
      </View>
      <View style={Gap(4)}>
        <RewardsOverview shopName={shopName} />
        <RewardsChart shopName={shopName} />
        <RewardsRedemption />
      </View>
    </EcoScrollView>
  );
}
